<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"
import { ChevronRight } from "lucide-vue-next"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <a
    data-slot="pagination-next"
    aria-label="Go to next page"
    :class="cn('inline-flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground cursor-pointer', props.class)"
  >
    <span>Next</span>
    <ChevronRight class="size-4" />
  </a>
</template>
